(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("i4mAD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2fdde288639e3c1e$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $2fdde288639e3c1e$var$FormSubmitButton = ({ text: text = "Skicka", isLoading: isLoading, disabled: disabled, desktopWidth: desktopWidth, shortButtonWidth: shortButtonWidth, justifyStart: justifyStart, justifyCenter: justifyCenter, redBtn: redBtn, roundCorners: roundCorners })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: `md:flex  w-full ${justifyStart === true ? "justify-start" : justifyCenter === true ? "justify-center" : "justify-end"} `,
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
            className: `${disabled ? "bg-grey300 hover:bg-grey300" : ""} text-white font-icb py-3 px-5 form-submit-button w-full outline-none ${roundCorners ? "rounded-full" : "rounded-md"} ${desktopWidth === "full" ? "" : "md:w-1/2"}  ${shortButtonWidth === true ? "md:w-3/12" : ""} ${redBtn === true ? "bg-red500 hover-darken-red500" : "bg-blue700 hover-darken-blue"} ${roundCorners ? "rounded-3xl" : "rounded-md"}`,
            type: "submit",
            disabled: disabled,
            children: isLoading ? /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                className: "loading-dot",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "mr-1",
                        children: "Laddar"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "dot"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "dot"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "dot"
                    })
                ]
            }) : text
        })
    });
};
var $2fdde288639e3c1e$export$2e2bcd8739ae039 = $2fdde288639e3c1e$var$FormSubmitButton;

});

})();
//# sourceMappingURL=FormSubmitButton.f90219c3.js.map
